enum RoutesPath {
  // Common routes
  Dashboard = "/dashboard",
  Properties = "/properties",
  PropertiesSearch = "/properties/search",
  PropertyPreview = "/properties/:id/preview",
  PropertyPreviewAsClient = "/properties/:id/preview-as-client/:brokerId",
  Portfolios = "/portfolios",
  PortfolioDetails = "/portfolios/:id",
  UnavailablePortfolioPage = "/unavailable-portfolio-page",
  Messages = "/messages",
  Profile = "/profile",
  SignIn = "/auth/sign-in",
  SignInMfa = "/auth/sign-in/mfa",
  SignUp = "/auth/sign-up",
  CompleteSignUpCodeConfirmation = "/auth/complete-sign-up",
  CompleteSignUpSSO = "/auth/complete-sign-up-sso",
  CompleteSignUpPickSubscription = "/auth/pick-subscription",
  CompleteSignUpAddAdditionalInfo = "/auth/add-additional-info",
  AccountCreated = "/auth/account-created",
  StripeCheckoutResult = "/auth/stripe-checkout-result",
  ForgotPassword = "/auth/forgot-password",
  ResetPassword = "/auth/resetPassword",
  EmailLinkAccess = "/auth/emailLinkAccess",
  ApiAccessAccept = "/api-access/accept",
  // IDX Paths
  Exchange = "/exchange",
  ExchangeDetails = "/exchange/:idxFeedId",
  ExchangeEmbeddedPortfolio = "/exchange/embedded/:idxFeedId/portfolio/:portfolioId",
  ExchangeEmbeddedProperty = "/exchange/embedded/:idxFeedId/property/:propertyId",
  ExchangeEmbeddedSearch = "/exchange/embedded/:idxFeedId/search-bar",
  ExchangeEmbeddedMarketArea = "/exchange/embedded/:idxFeedId/market-area",
  ExchangeUnauthorized = "/exchange/error/unauthorized",
  // public urls
  PortfolioPreview = "/portfolio-folder/:brokerId/:brokerName/:portfolioFolderName",
  PropertyInPortfolioPreview = "/portfolio-folder-item/:brokerId/:brokerName/:portfolioFolderName/:portfolioName",
  PortfolioPropertyPreview = "/portfolio-item/:brokerId/:brokerName/:portfolioName",
  ShareProperty = "/share/:brokerId/:brokerName/:propertyId/:propertyName",
  ShareFeaturedPortfolio = "/share-portfolio/:brokerId/:brokerName/:id",
  FeaturedPortfolioPreview = "/featured-portfolio/:id",
  Watchlist = "/watchlist",
  TermConditions = "/terms-of-service",
  PrivacyPolicy = "/privacy-policy",
  SSOCallback = "/auth/sso-callback",
}

export { RoutesPath };
